import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { CONTENT_PAGE_ROUTES, DNA_APP_ROUTES, PAGE_TYPES } from '../config/routes'

const Home = lazy(() => import("./pages/home"))
const Pages = lazy(() => import('./Pages'))
const AboutPage = lazy(() => import('./pages/about'))
const PolicyPage = lazy(() => import('./pages/policies'))
const TermsPage = lazy(() => import('./pages/terms'))
const DnaRouteView = lazy(() => import('../apps/dna/DnaRouteView'))

const renderContentRoute = (type) => {
  if (type === PAGE_TYPES.ABOUT) {
    return <AboutPage />
  }

  if (type === PAGE_TYPES.POLICY) {
    return <PolicyPage />
  }

  if (type === PAGE_TYPES.TERMS) {
    return <TermsPage />
  }

  return <Pages type={type} />
}

function ScrollBehavior() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('scrollRestoration' in window.history)) {
      return undefined
    }

    const previousValue = window.history.scrollRestoration
    window.history.scrollRestoration = 'manual'

    return () => {
      window.history.scrollRestoration = previousValue
    }
  }, [])

  return null
}

function AppRouter() {
    return (
        <Router>
          <ScrollBehavior />
          <Suspense fallback={<div className="App" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              {CONTENT_PAGE_ROUTES.map(({ path, type }) => (
                <Route key={path} path={path} element={renderContentRoute(type)} />
              ))}
              {DNA_APP_ROUTES.map(({ path, type }) => (
                <Route key={path} path={path} element={<DnaRouteView routeType={type} />} />
              ))}
            </Routes>
          </Suspense>
        </Router>
      )
}

export default AppRouter
